import React from "react";

export default function LoadingPage({ top, width, left }) {
  return (
    <>
      <img
        width={width ?? 40}
        className="loading-image"
        src="/images/icon/load.gif"
        alt="Loading..."
        style={{
          position: "absolute",
          top: top ?? "50%",
          left: left ?? "50%",
          transform: "translate(-50%, -50%)",
          zIndex: 2,
        }}
      />
    </>
  );
}
